export const MAX_QUANTITY = 20;
export const getTotalQuantity = (cartProducts: { quantity: number }[]) =>
  (cartProducts ?? []).reduce(
    (prevValue, product) => prevValue + product.quantity,
    0
  );
